import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./footer.css";
import BJT_Logo from "../../assets/Images/blackjadetattoo-logo2.png";

export default function Footer() {
  const getDate = new Date();
  const getYear = getDate.getFullYear();

  const [year, setYear] = useState(getYear);

  return (
    <>
      <div id="footer">
        <div className="row">
          <div className="col-lg-4 col-md-6" id="footer-left">
            <img src={BJT_Logo} alt="" id="footer-logo" />
            <p>
              Black Jade Tattoo was created in 2020 housing highly skilled
              artists providing a diverse range of style that the modern tattoo
              world has to offer.
            </p>

            <p>Business Licence : #011224</p>
            <div className="footer_social">
              <a
                href="https://www.instagram.com/blackjadetattoo/"
                target="_blank"
              >
                <i className="fab fa-instagram social-icon"></i>
              </a>
              <a
                href="https://www.facebook.com/blackjadetattoo/"
                target="_blank"
              >
                <i className="fab fa-facebook social-icon"></i>
              </a>
            </div>
          </div>

          <div className="col-lg-8 col-md-6" id="footer-right">
            <div id="quick-links">
              <h5>QUICK LINKS</h5>
              <ul>
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li>
                  <NavLink to="/about">About</NavLink>
                </li>
                <li>
                  <NavLink to="/service">Service</NavLink>
                </li>
                <li>
                  <NavLink to="/artists">Artists</NavLink>
                </li>
                <li>
                  <NavLink to="/blog">Blog</NavLink>
                </li>
                <li>
                  <NavLink to="/contact">Contact</NavLink>
                </li>
                <li>
                  <NavLink to="/booking">Booking</NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom-section">
          <hr />
          <div className="footer-bottom-content">
            <span id="footer-copyright">
              <p>
                © {year} Black Jade Tattoo |{" "}
                <a
                  href="https://pixelhaus.com.au/"
                  target="_blank"
                  rel="noopener noreferrer"
                  id="footer-builtby"
                >
                  Built by Pixel Haus
                </a>
              </p>
            </span>{" "}
          </div>
        </div>
      </div>
    </>
  );
}
